/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React, { FC } from 'react';
import { StyleSheet } from 'aphrodite';
import { ActionButton as Button, ActionButtonProps as ButtonProps, fonts } from '@blend/consumer-components';
import { useConsumerTheme } from '../../hooks/useConsumerTheme';

const styles = StyleSheet.create({
  button: {
    fontSize: 16,
    fontWeight: fonts.weight.medium,
  },
});

export namespace ActionButton {
  export interface Props extends Omit<ButtonProps, 'color'> {
    color?: string;
    disabled?: boolean;
  }
}

export const ActionButton: FC<ActionButton.Props> = ({ children, color, ...props }) => {
  const {
    appConfig: { colors },
  } = useConsumerTheme();
  return (
    <Button
      color={color || colors.action}
      customStyle={styles.button}
      {...props}
      data-dd-privacy="allow"
      disabled={props.disabled}
    >
      {children}
    </Button>
  );
};
